module.exports = "/_next/static/images/hk-679d5ec38d71530f840d78633848bd13.svg";